import React from 'react';
import PropTypes from 'prop-types';
import { InputContext, InputContextProps } from '../../InputContext';

type InputConsumerProps = {
  consumerCompName?: string;
  children: (context: InputContextProps) => React.ReactNode;
};

export const InputConsumer = ({
  consumerCompName = 'InputConsumer',
  children,
}: InputConsumerProps) => {
  if (typeof children !== 'function') {
    throw new Error(
      `child of ${consumerCompName} must be a context consumer function`,
    );
  }
  return (
    <InputContext.Consumer>
      {context => {
        if (!context) {
          throw new Error(
            `${consumerCompName} cannot be rendered outside the Input component`,
          );
        }
        return children(context);
      }}
    </InputContext.Consumer>
  );
};

InputConsumer.propTypes = {
  children: PropTypes.any.isRequired,
  consumerCompName: PropTypes.string,
};
